import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Card, CardBody, Button, Input, FormFeedback } from 'reactstrap';
import LinksForm from 'components/forms/LinksForm';
import FormButtons from 'components/FormButtons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import { formValueSelector, arrayPush, change } from 'redux-form';
import predictUrlType from 'lib/predictUrlType';
import addHttpPrefix from 'lib/utils/addHttpPrefix';
import InfoLink from '../../components/InfoLink'

class LinksPage extends Component {
  static propTypes = {
    urlTypes: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    links: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    formErrors: ImmutablePropTypes.map.isRequired,
    saveDraft: PropTypes.func.isRequired,
    pricingType: PropTypes.string.isRequired,
    config: ImmutablePropTypes.map.isRequired,
  };

  state = {
    url: '',
    submissionTried: false,
    urlIsValid: null,
  }

  submitForm = () => {
    const links_count = this.props.links.length;
    this.setState(() => ({ submissionTried: true }));
    if (window.GLOBAL_SKIP_VALIDATIONS || !this.props.config.get('urls_required', true) && links_count === 0) {
      this.formSubmitted({});
    } else if (links_count > 0) {
      this.form.submit();
    }
  }

  formSubmitted = (data) => this.props.submitForm('links', this.props.history, data);
  saveDraft = () => this.props.saveDraft('links');
  goToPreviousStep = () => this.props.goToPreviousStep('links', this.props.history);

  onUrlChange = (e) => {
    this.setState({ url: e.target.value });
    this.validateUrl(e);
  }

  validateUrl = (e) => {
    const urlRgx = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
    if (urlRgx.test(e.target.value)) {
      this.setState({ urlIsValid: true });
    } else {
      this.setState({ urlIsValid: false });
    }
  }

  submitLink = (e) => {
    e.preventDefault();
    this.addNewLink(this.state.url);
    this.setState({ url: '', urlIsValid: null });
  }

  addNewLink = (url) => {
    const isPrimary = !this.props.links || this.props.links.length === 0;
    this.props.dispatch(
      arrayPush('eventSubmission', 'links', {
        url: addHttpPrefix(url).replace(/\s/g, ''),
        is_primary: isPrimary,
        type: predictUrlType(this.props.urlTypes, url),
      })
    );
  }

  setLinkAsPrimary = (index) => {
    this.props.links.map((link, link_index) => {
      const is_primary = index === link_index;
      if (link.is_primary || is_primary) {
        this.props.dispatch(change('eventSubmission', `links[${link_index}].is_primary`, is_primary));
      }
    });
  }

  render() {
    const { links } = this.props;
    const countErrorVisible = this.state.submissionTried && links.length === 0;

    return (
      <div>
        <FormButtons onNext={this.submitForm} onPrevious={this.goToPreviousStep} onSaveDraft={this.saveDraft} />
        <div className="row justify-content-center">
          <div className="col-md-10">
            <Card>
              <div className="card-header">
                <h4>
                  URLs
                  <InfoLink link="https://support.evvnt.com/hc/en-us/articles/360020725534-Links-Adding-links-to-your-event"/>
                </h4>
              </div>
              <CardBody>
                <p>
                  <b>Add URLs to your event ensuring the primary link is the most important - e.g. Ticketing</b>
                </p>
                {links && links.length > 0 && <div>
                  <LinksForm
                    ref={(ref) => this.form = ref}
                    onSubmit={this.formSubmitted}
                    urlTypes={this.props.urlTypes}
                    onSetAsPrimary={this.setLinkAsPrimary}
                    formErrors={this.props.formErrors}
                    pricingType={this.props.pricingType}
                  />
                  <p>
                    <b>Add URLs to your social media, artist pages or relevant videos</b>
                  </p>
                </div>}
                <form className="mb-4" onSubmit={this.submitLink}>
                  <div className="row">
                    <div className="col">
                      <Input
                        onChange={this.onUrlChange}
                        value={this.state.url}
                        valid={this.state.urlIsValid}
                        placeholder="Enter URL"
                      />
                      <FormFeedback>That doesn't look like a URL</FormFeedback>
                    </div>
                    <div className="col-4 col-lg-2">
                      <Button type="submit" color="info" block disabled={!this.state.urlIsValid}>+ Add</Button>
                    </div>
                  </div>
                </form>
                <p>
                  Each URL traffic will be measured using our link tracking technology.
                </p>
                {countErrorVisible && <p className="text-danger">Add at least one link</p>}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  urlTypes: state.urlTypes,
  pricingType: formValueSelector('eventSubmission')(state, 'pricing_type'),
  links: formValueSelector('eventSubmission')(state, 'links'),
  formErrors: state.submissionForm.getIn(['steps', 'links', 'errors']),
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinksPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/LinksPage.jsx